/**
 * @publicApi
 */
const NGXS_DATA_STORAGE_EVENT_TYPE = 'NGXS_DATA_STORAGE_EVENT_TYPE';

const NGXS_COMPUTED_OPTION = 'NGXS_COMPUTED_OPTION';

const NGXS_DATA_META = 'NGXS_DATA_META';

const NGXS_META_KEY = 'NGXS_META';

const NGXS_ARGUMENT_REGISTRY_META = 'NGXS_ARGUMENT_REGISTRY_META';

/**
 * Generated bundle index. Do not edit.
 */

export { NGXS_ARGUMENT_REGISTRY_META, NGXS_COMPUTED_OPTION, NGXS_DATA_META, NGXS_DATA_STORAGE_EVENT_TYPE, NGXS_META_KEY };
